
$('.index-review-slider').slick({
  autoplay: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,      
  dots: false
});

$('.featured-products-custom-slider').slick({
    autoplay: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
        centerMode: true,
    prevArrow: '<div class="slick-prev"></div>',
    nextArrow: '<div class="slick-next"></div>',
    dots: false,
    responsive: [
        {
        breakpoint: 769,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
        }
    },
    {
        breakpoint: 426,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
        }
    }
]
});
